import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// img imports

import About_img from "../Assets/Images/about.jpg";
import { title } from "../config/Config";

const About_main = () => {
    return (
        <div className="about-sec">
            <Container>
                <Row>
                    <div className="about_inner">
                        <Row>
                            <Col lg={6}>
                                <div className="About_img">
                                    <img src={About_img} alt="about img" />
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="About_wrapper">
                                    <h5>Discover the Essence of True Wellness</h5>
                                    <p>
                                        At {title}, we combine the ancient wisdom of Ayurveda
                                        with modern care to restore harmony between your body, mind,
                                        and spirit.
                                    </p>
                                    <p>
                                        Our treatments are rooted in centuries-old traditions, using
                                        only pure, natural herbs and time-tested practices to awaken
                                        your body’s own healing power. From easing chronic ailments to
                                        boosting daily vitality, every remedy is designed to nurture
                                        you from within.
                                    </p>
                                    <p>
                                        Step into a journey where nature meets science, and experience
                                        the balance, energy, and peace your body truly deserves.
                                    </p>
                                    <div className="button_main">
                                        <a href="product" className="btn-main">
                                            Shop Now
                                        </a>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Row>
            </Container>
        </div>
    );
};
export default About_main;
